import gql from 'graphql-tag'

export const COMMISSION_TURNOVER_REPORTS_CREATE_MUTATION = gql`
    mutation commissionTurnoverReportsCreate(
        $consultingEntityIds: [ID!]!
        $dateFrom: Date!
        $dateUntil: Date!
    ) {
        commissionTurnoverReportsCreate(
            consulting_entity_ids: $consultingEntityIds
            date_from: $dateFrom
            date_until: $dateUntil
        ) {
            status
        }
    }
`
